import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import { Row, Col, Section, Container } from '@webteam/layout';
import { useBreakpoint } from '@webteam/breakpoints';

import './head-case-study-section.pcss';

const HeadCaseStudySection = ({
  title,
  industry,
  img,
  country,
  size,
  usedProductTitle = null,
  usedProductLink = null
}) => {
  const bp = useBreakpoint();

  return (
    <React.Fragment>
      <Section className="wt-section_bg_dark head-case-study-section">
        <Container className="wt-offset-top-96">
          <Row>
            <Col span="inline">
              <h1 className="rs-hero rs-hero_theme_dark mpp-page-title">{title}</h1>
            </Col>
          </Row>
          <Row justify="start" className="wt-offset-top-48">
            <Col
              span={bp(4, { sm: 12 })}
              className="rs-text-2 rs-text-2_theme_dark rs-text-2_hardness_hard"
            >
              Company: {title}
              <br />
              Industry: {industry}
            </Col>
            <Col
              span={bp(4, { sm: 12 })}
              className="rs-text-2 rs-text-2_theme_dark rs-text-2_hardness_hard"
            >
              Size: {size}
              {usedProductTitle && (
                <React.Fragment>
                  <br />
                  JetBrains products used:{' '}
                  <a href={usedProductLink} className="wt-link">
                    {usedProductTitle}
                  </a>
                </React.Fragment>
              )}
            </Col>
            <Col
              span={bp(4, { sm: 12 })}
              className="rs-text-2 rs-text-2_theme_dark rs-text-2_hardness_hard"
            >
              Country: {country}
            </Col>
          </Row>
        </Container>
      </Section>

      <Section className="image-section">
        <Container className="wt-display-sm-none">
          <Img fluid={img} alt={title} />
        </Container>
        <Img
          className="wt-display-none wt-display-sm-block"
          fluid={img}
          alt={title}
        />
      </Section>
    </React.Fragment>
  );
};

HeadCaseStudySection.propTypes = {
  title: PropTypes.string,
  img: PropTypes.object,
  country: PropTypes.string,
  size: PropTypes.string,
  industry: PropTypes.string,
  usedProductTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null])
  ]),
  usedProductLink: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null])
  ])
};

export default HeadCaseStudySection;
